import ScheduleModel from "@/models/lab/ScheduleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ScheduleCollection extends LabServiceCollection {
  model() {
    return ScheduleModel;
  }

}
